<div class="loading-page" [ngClass]="position">
    <mat-spinner
        strokeWidth="4"
        [diameter]="diameter"
        [color]="color"></mat-spinner>
</div>
